import React, { Component } from "react"

import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import classNames from "classnames"

/**
 * List item for navigation.
 */
class NavListItem extends Component {
    render() {
        const navItemClassNames = classNames(
            "nav-item",
            {
                active: this.props.isActive === true,
                disabled: this.props.isDisabled === true
            },
            this.props.className ? this.props.className : null
        )
        return (
            <li className={navItemClassNames}>
                {this.props.path ? (
                    (this.props.path.includes('http'))
                    ?
                    <a className="nav-link" target="_blank" rel="noreferrer" href={this.props.path}>{this.props.title}</a>
                    :
                    <Link
                        to={this.props.path}
                        className="nav-link"
                        onClick={this.props.onClick}
                    >
                        {this.props.icon ? this.props.icon : null}
                        <span className="label">{this.props.title}</span>
                    </Link>
                ) : (
                    <span
                        className="nav-link"
                        onClick={this.props.onClick}
                    >
                        {this.props.icon ? this.props.icon : null}
                        <span className="label">{this.props.title}</span>
                    </span>
                )}
            </li>
        )
    }

    static propTypes = {
        className: PropTypes.string,
        path: PropTypes.string,
        isActive: PropTypes.bool,
        isDisabled: PropTypes.bool,
        onClick: PropTypes.func,
        icon: PropTypes.node,
        title: PropTypes.string.isRequired
    }
}

export default NavListItem
